import { connect } from "react-redux";
import { registerTabsGroup, setActiveTab } from "actions/tabs";
import Tab from "components/elements/tabs/tab";
import TabContent from "components/elements/tabs/tab-content";

const mapStateToProps = (state, props) => ({
  isActive: state.tabs[props.group] === props.name,
});

const mapDispatchToProps = { registerTabsGroup, setActiveTab };

export default {
  Tab: connect(mapStateToProps, mapDispatchToProps)(Tab),
  TabContent: connect(mapStateToProps, mapDispatchToProps)(TabContent),
};
